import React from 'react'
import PropTypes from 'prop-types'
import DesktopWorks from './DesktopWorks'
import MobileWorks from './MobileWorks'
import withWindowSize from '../hoc/withWindowSize'
import { HEADER_HEIGHT_SMALL, HEADER_HEIGHT } from '../constants'

const getHeight = (isMobile, ww, wh) => {
  if (isMobile) return 'auto'
  if (ww >= 1200 && wh <= 800) return wh - HEADER_HEIGHT_SMALL
  return wh - HEADER_HEIGHT
}

const Works = ({
  isMobile, innerWidth, windowWidth, windowHeight, ...rest
}) => (
  <div
    className="works"
    style={{ height: getHeight(isMobile, windowWidth, windowHeight) }}
  >
    {isMobile && (
      <MobileWorks width={windowWidth} />
    )}

    {!isMobile && (
      <DesktopWorks
        width={innerWidth}
        height={windowHeight}
        {...rest}
      />
    )}
  </div>
)

Works.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  windowWidth: PropTypes.number.isRequired,
  windowHeight: PropTypes.number.isRequired,
  innerWidth: PropTypes.number.isRequired,
}

export default withWindowSize(Works)



// WEBPACK FOOTER //
// ./src/components/Works.js